import { LocalStorage } from './local-storage.js';

const Cookie = {
    get: (name, def = "")=>{
        const extendedName = `${name}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const result = decodedCookie.split(";").map((item)=>item.replace(/^\s+/, "")).find((item)=>item.startsWith(extendedName));
        if (result) {
            return result.replace(extendedName, "");
        }
        // Fake cookie
        const localData = LocalStorage.get(name);
        if (localData) {
            const { ttl = 0, value } = JSON.parse(localData);
            if (Date.now() > ttl) {
                LocalStorage.remove(name);
            } else {
                return value;
            }
        }
        return def;
    },
    set: (name, value, exmin = 24)=>{
        let expires = "Thu, 01 Jan 1970 00:00:00 GMT";
        const isHttps = window?.location?.protocol === "https:";
        const domain = `.${window.location.hostname}`;
        // Törlés
        if (value !== undefined && value !== "") {
            const d = new Date();
            d.setTime(d.getTime() + exmin * 60 * 1000);
            expires = d.toUTCString();
        }
        document.cookie = `${encodeURI(name)}=${encodeURI(value)};expires=${expires};domain=${domain};path=/;${isHttps ? "Secure;SameSite=None" : "SameSite=Strict"}`;
        // Fake cookie
        const cookieList = (LocalStorage.get("bm-cookie-list") || "").split(";").filter(Boolean);
        if (value === undefined || value === "") {
            LocalStorage.remove(name);
            cookieList.filter((cookieName)=>name === cookieName);
        } else {
            LocalStorage.set(name, JSON.stringify({
                value,
                ttl: Date.now() + exmin * 60 * 1000
            }));
            if (!cookieList.includes(name)) {
                cookieList.push(name);
            }
        }
        LocalStorage.set("bm-cookie-list", cookieList.join(";"));
    }
};

export { Cookie };
//# sourceMappingURL=cookie.js.map
